import Alerts from "components/modules/SingleDashboard/Alerts";
import Anomalies from "components/modules/SingleDashboard/Anomalies";
import DeviceUsers from "components/modules/SingleDashboard/DeviceUsers";
import DeviceSession from "components/modules/SingleDashboard/DeviceSession";
import { devicesActions } from "../redux/slice/devices.slice";
import { getDashboardNavItems } from "components/modules/SingleDashboard/helper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AppsContainer from "../components/modules/Apps/AppsContainer";
import Fim from "../components/modules/Fim/Fim";
import SingleDashboard from "../components/modules/SingleDashboard/SingleDashboard";
import CustomNavTabs from "../components/shared/CustomNavTabs";
import { accessActions } from "../redux/slice/access.slice";
import { applicationsActions } from "../redux/slice/applications.slice";
import { authActions } from "../redux/slice/auth.slice";
import { packagesActions } from "../redux/slice/packages.slice";
import { uiActions } from "../redux/slice/ui.slice";
import { FETCH_GROUPS } from "../redux/types/group.types";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper";
import toast from "react-hot-toast";

const SingleDashboardPage = () => {
    const dispatch = useDispatch();
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectedTab = (value) => {
    setSelectedTab(value);
  };


   useEffect(() => {
    return () => {
      dispatch(
        devicesActions.actions.setDevicesession({
          data: [],
          meta: {},
          filterKey: "all",
        })
      );
      dispatch(
        devicesActions.actions.setDeviceStartedSessions({
          data: [],
          meta: {},
          filterKey: "all",
        })
      );
    };
  }, [dispatch]);


  useEffect(() => {
    if (userPermissions?.length && currentUser?.role) {
      if (!checkSinglePermission(USER_PERMISSIONS.VIEW_DEVICE_DETAILS, userPermissions, currentUser?.role)) {
        toast.error(" You do not have permission to view this page.");
        navigate("/devices");
      }
    }
  }, [userPermissions, currentUser?.role, navigate])

  useEffect(() => {
    dispatch({ type: FETCH_GROUPS });
    dispatch(uiActions.actions.setSelectedNav(""));
  }, [dispatch, id, currentUser]);


  const handleComponents = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return <SingleDashboard />;
      case 1:
        return <AppsContainer />;
      case 2:
        return <Fim />;
      case 3:
        return <Alerts />;
      case 4:
        return <Anomalies />;
      case 5:
        return <DeviceUsers />;
      case 6:
        return <DeviceSession />;
      default:
        return <SingleDashboard />;
    }
  };


  const navItems = getDashboardNavItems({
    isAppsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_INSTALLED_APPLICATIONS, userPermissions, currentUser?.role),
    isFimAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_FILE_INTEGRITY_MANAGEMENT, userPermissions, currentUser?.role),
    isAlertsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ALERTS, userPermissions, currentUser?.role),
    isAnomaliesAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ANOMALIES, userPermissions, currentUser?.role),
    isDeviceUsersAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_DEVICE_USERS, userPermissions, currentUser?.role),
    selectedTab,
  })

  return (
    <div>
      <CustomNavTabs
        selectedTab={selectedTab}
        handleSelectedTab={handleSelectedTab}
        navItems={navItems}
      />
      {handleComponents(selectedTab)}
    </div>
  );
};

export default SingleDashboardPage;

